export default __webpack_public_path__ + "static/media/years_in_salary_grade.c8789a49.svg";